import { ENDPOINT } from '~/constants';

import { isAbortError, type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type MappingsFieldsResponse } from './types';

/**
 * Fetches all available Document Intelligence field names from mappings.json.
 * @param options - Request options.
 * @returns A list of available field names and their count.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/get_mappings_fields_get_mappings_fields_get
 */
export const fetchMappingsFields = async (options?: KyRequestOptions) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.GET_MAPPINGS_FIELDS(), {
        ...options,
      })
      .json<MappingsFieldsResponse>();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }

    log.error({
      message: 'Error fetching Document Intelligence field mappings',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
